<template>
  <div class="d-flex justify-center chart-container">
    <Bar :key="chartKey" :data="chartData" :options="chartOptions" 
    :style="chartDimensions"/>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  CategoryScale,
} from "chart.js";
import { useDisplay } from "vuetify";
import { computed, ref, watch } from "vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale);

export default {
  components: { Bar },
  props: ["weeklyLogins", "completedHomework", "days"],
  setup(props) {
    const { name } = useDisplay();
    const chartKey = ref(0);

    const chartData = computed(() => ({
      labels: props.days,
      datasets: [
        {
          label: "Logins",
          data: props.weeklyLogins,
          backgroundColor: "#ff6d44",
          borderRadius: 5,
        },
        {
          label: "Completed Homework",
          data: props.completedHomework,
          backgroundColor: "#08b6aa",
          borderRadius: 5,
        },
      ],
    }));

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
      },
      scales: {
        x: {
          grid: { display: false },
          title: {
            display: true,
            text: "Days",
          },
        },
        y: {
          beginAtZero: true,
          grid: { color: "rgba(255, 255, 255, 0.2)" },
          title: {
            display: true,
            text: "Number",
          },
        },
      },
    };

    const chartDimensions = computed(() => {
      switch (name.value) {
        case "xs":
          return { width: "200px", height: "200px" };
        case "sm":
          return { width: "90%", height: "300px" };
        case "md":
          return { width: "90%", height: "400px" };
        case "lg":
          return { width: "90%", height: "600px" };
        case "xl":
        case "xxl":
          return { width: "90%", height: "800px" };
        default:
          return {};
      }
    });

    watch(name, () => {
      console.log("Screen size changed");
      chartKey.value++; // Force re-render of the chart
    });

    return { name, chartKey, chartData, chartOptions, chartDimensions };
  },
};
</script>

<style>
.chart-container {
  position: relative;
  height: 40vh;
  width: 80vw;
  max-width: 100%; /* Prevents overflow */
}
</style>
